import { makeApi } from "@zodios/core";
import { z } from "zod";

import { moduleSchema } from "../../interactModules.ts";
import { GenerationErrorResponse } from "../response.ts";

export const SceneSuggestion = z.object({
  title: z.string().describe("A succinct title to summarize the learning objective"),
  learningObjective: z.string().describe("The learning objective"),
});

export type SceneSuggestion = z.infer<typeof SceneSuggestion>;

export const SceneSuggestions = z.object({
  sceneSuggestions: z
    .array(SceneSuggestion)
    .describe("A list of scene suggestions based on the learning objective")
    .default([]),
});

export type SceneSuggestions = z.infer<typeof SceneSuggestions>;

export const sceneSuggestionsApi = makeApi([
  {
    method: "get",
    path: "/copilot/scene-suggestions/list",
    alias: "getSceneSuggestions",
    parameters: [
      {
        type: "Query",
        name: "interactModule",
        // readonly is omitted: query-string booleans arrive as "true"/"false"
        // strings and fail z.boolean() validation. The handler doesn't use it.
        schema: moduleSchema.omit({ readonly: true }).partial(),
      },
    ],
    response: SceneSuggestions,
    errors: [
      { status: 400, schema: GenerationErrorResponse },
      { status: 401, schema: z.string() },
    ],
  },
]);
